import { FC, PropsWithChildren, createContext, useContext } from 'react';

import { User } from '@/features/auth/types';

// Cookie (BFF) session: the server owns authentication, the app only knows who
// is signed in and how to end the session. Logout is a navigation - the
// HttpOnly cookie cannot be touched from JS.
export interface AppAuthContextValue {
  user: User;
  logout: () => void;
}

const AppAuthContext = createContext<AppAuthContextValue | null>(null);

export const AppAuthProvider: FC<PropsWithChildren<{ value: AppAuthContextValue }>> = ({
  value,
  children,
}) => <AppAuthContext.Provider value={value}>{children}</AppAuthContext.Provider>;

export const useAppAuth = (): AppAuthContextValue => {
  const context = useContext(AppAuthContext);
  if (!context) {
    throw new Error('useAppAuth must be used within AppAuthProvider');
  }

  return context;
};
